import { Link, type LinkProps } from '@mui/material'
import React from 'react'
import {
  Link as RouterLink,
  type LinkProps as RouterLinkProps
} from 'react-router-dom'

import Icon, { type IconName } from 'components/Icon'
import { muiTheme } from 'mui-theme'

export const BreadcrumbLink: React.FC<
  {
    icon?: IconName
    name: string
    to: string
  } & LinkProps &
    RouterLinkProps
> = ({ icon, name, to, ...rest }) => (
  <Link key={name} component={RouterLink} to={to} underline="hover" {...rest}>
    {icon && <Icon css={{ marginRight: muiTheme.spacing(1) }} icon={icon} />}
    {name}
  </Link>
)
